module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.feedback),
      expression: "!feedback"
    }],
    staticClass: "scene animated fadeIn"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": 'media/page3/' + _vm.items.activity.scenes[_vm.id].image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.items.activity.scenes[_vm.id].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.items.activity.scenes[_vm.id].text))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.items.activity.scenes[_vm.id].prompt))])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, _vm._l((_vm.items.activity.scenes[_vm.id].options), function(item, index) {
    return _c('button', {
      staticClass: "fas",
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feedback),
      expression: "feedback"
    }],
    staticClass: "feedback animated fadeIn"
  }, [_c('h2', [_vm._v(_vm._s(_vm.items.activity.scenes[0].options[0].feedHead))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.items.activity.scenes[_vm.id].options[_vm.feedId].feedback)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button back",
    on: {
      "click": _vm.tryAgain
    }
  }, [_vm._v(_vm._s(_vm.items.activity.scenes[0].buttons[1]))]), _vm._v(" "), _c('button', {
    staticClass: "button forward",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.items.activity.scenes[0].buttons[2]))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b57b83c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/components/Popup.vue
// module id = 148
// module chunks = 0